
const mapZoom = {
  zoom: 5,
  communities: {
    1: { // andalucia
      zoom: 6.3,
      provinces: {
        4: { zoom: 8 }, // almeria
        11: { zoom: 7.5 }, // cadiz
        14: { zoom: 7.5 }, // cordoba
        18: { zoom: 7.7 }, // granada
        21: { zoom: 7.8 }, // huelva
        23: { zoom: 7.8 }, // jaen
        29: { zoom: 7.8 }, // malaga
        41: { zoom: 8 }, // sevilla
      },
    },
    2: { // aragon
      zoom: 6.3,
      provinces: {
        22: { zoom: 7.5 }, // huesca
        44: { zoom: 7.5 }, // teruel
        50: { zoom: 7.4 }, // zaragoza
      },
    },
    3: { // asturias
      zoom: 7.3,
      provinces: {
        33: { zoom: 7.3 }, // asturias
      },
    },
    4: { // islas baleares
      zoom: 7,
      provinces: {
        7: { zoom: 7 }, // islas baleares
      },
    },
    5: { // canarias
      zoom: 6.5,
      provinces: {
        35: { zoom: 7.5 }, // las palmas
        38: { zoom: 7.7 }, // santa cruz de tenerife
        // islas
        3501: { zoom: 8.0 }, // fuerteventura
        3502: { zoom: 8.5 }, // gran canaria
        3503: { zoom: 8.5 }, // lanzarote
        3801: { zoom: 9.0 }, // gomera
        3802: { zoom: 9.0 }, // hierro
        3803: { zoom: 9.0 }, // palma
        3804: { zoom: 8.5 }, // tenerife
      },
    },
    6: { // cantabria
      zoom: 8.0,
      provinces: {
        39: { zoom: 8.0 }, // cantabria
      },
    },
    7: { // castilla y leon
      zoom: 6.3,
      provinces: {
        5: { zoom: 7.5 }, // avila
        9: { zoom: 7.5 }, // burgos
        24: { zoom: 7.5 }, // leon
        34: { zoom: 7.5 }, // palencia
        37: { zoom: 7.5 }, // salamanca
        40: { zoom: 7.5 }, // segovia
        42: { zoom: 7.5 }, // soria
        47: { zoom: 7.5 }, // valladolid
        49: { zoom: 7.5 }, // zamora
      },
    },
    8: { // castilla - la mancha
      zoom: 6.5,
      provinces: {
        2: { zoom: 7.5 }, // albacete
        13: { zoom: 7.5 }, // ciudad real
        16: { zoom: 7.5 }, // cuenca
        19: { zoom: 7.5 }, // guadalajara
        45: { zoom: 7.5 }, // toledo
      },
    },
    9: { // cataluña
      zoom: 7.0,
      provinces: {
        8: { zoom: 7.5 }, // barcelona
        17: { zoom: 7.5 }, // girona
        25: { zoom: 7.5 }, // lleida
        43: { zoom: 7.5 }, // tarragona
      },
    },
    10: { // comunidad valenciana
      zoom: 6.5,
      provinces: {
        3: { zoom: 7.5 }, // alicante
        12: { zoom: 7.5 }, // castellon
        46: { zoom: 7.5 }, // valencia
      },
    },
    11: { // extremadura
      zoom: 6.5,
      provinces: {
        6: { zoom: 7.5 }, // badajoz
        10: { zoom: 7.5 }, // caceres
      },
    },
    12: { // galicia
      zoom: 6.5,
      provinces: {
        15: { zoom: 7.5 }, // a coruna
        27: { zoom: 7.5 }, // lugo
        32: { zoom: 7.5 }, // ourense
        36: { zoom: 7.5 }, // pontevedra
      },
    },
    13: { // comunidad de madrid
      zoom: 7.5,
      provinces: {
        28: { zoom: 7.5 }, // madrid
      },
    },
    14: { // region de murcia
      zoom: 7.5,
      provinces: {
        30: { zoom: 7.5 }, // murcia
      },
    },
    15: { // navarra
      zoom: 7.5,
      provinces: {
        31: { zoom: 7.5 }, // navarra
      },
    },
    16: { // pais vasco
      zoom: 7.5,
      provinces: {
        1: { zoom: 8.5 }, // alava
        20: { zoom: 8.5 }, // guipuzkoa
        48: { zoom: 8.5 }, // bizkaia
      },
    },
    17: { // la rioja
      zoom: 8.0,
      provinces: {
        26: { zoom: 8.5 }, // la rioja
      },
    },
    18: { // ceuta
      zoom: 11,
      provinces: {
        51: { zoom: 12 }, // ceuta
      },
    },
    19: { // melilla
      zoom: 12,
      provinces: {
        52: { zoom: 11 }, // melilla
      },
    },
  },
};

export default mapZoom;
